// extracted by mini-css-extract-plugin
export var fullscreenPage = "Tabbar-module--fullscreen-page--44206";
export var tabsWrapperStyle = "Tabbar-module--tabsWrapperStyle--fba98";